const PROFILE_STORAGE_KEY = 'userProfile'

export const getStoredProfile = () => {
  const stored = localStorage.getItem(PROFILE_STORAGE_KEY)
  if (stored) {
    try {
      return JSON.parse(stored)
    } catch (e) {
      if (process.env.NODE_ENV === 'development') console.error('Error parsing stored profile:', e)
    }
  }
  return null
}

export const storeProfile = (profileData) => {
  try {
    localStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(profileData))
    return true
  } catch (e) {
    if (process.env.NODE_ENV === 'development') console.error('Error storing profile:', e)
    return false
  }
}